import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { ICourse } from "../courseModel";

export const getAllCourse = createAsyncThunk(
  "Course/FindAllCourse",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Course/FindAllCourse`,
        {
          Title: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Course:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createCourse = createAsyncThunk(
  "Course/InsertCourse",
  async (CourseData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Course/InsertCourse`,
        CourseData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating Course:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateCourse = createAsyncThunk(
  "Course/UpdateCourse",
  async (CourseData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Course/UpdateCourse`,
        CourseData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Course :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteCourse = createAsyncThunk(
  "Course/DeleteCourse",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Course/DeleteCourse`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Course :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getCourseByID = createAsyncThunk(
  "Course/FindByIDCourse",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Course/FindByIDCourse`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        Title: result.Title,
        Description: result.Description,
        URL: result.URL,
        Logo:result.Logo,
        IsActive: result.IsActive ? 1 : 2,
      } as ICourse;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Course :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveCourse = createAsyncThunk(
  "Course/FindAllActiveCourse",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/Course/FindAllActiveCourse`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Course:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveCourse = createAsyncThunk(
  "Course/ActiveInActiveCourse",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Course/ActiveInActiveCourse`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Course :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

// IMAGE UPLOAD

export const CourseImageUpload = createAsyncThunk(
  "Course/CourseImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Course/CourseImageUpdate`,
        formData,
        {
          headers: { "content-type": "multipart/form-data" },
        }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Course Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
